import {useEffect} from 'react';

import {ensighten} from 'shared/Ensighten/components';

export const useUserConnectionLogger = () => {
  useEffect(() => {
    const logUserOnline = () =>
      ensighten.ensightenLogger({
        logInfo: `Customer has regained network connection`
      });

    const logUserOffline = () =>
      ensighten.ensightenLogger({
        logInfo: `Customer has lost network connection`
      });

    window.addEventListener('online', logUserOnline);
    window.addEventListener('offline', logUserOffline);

    return () => {
      window.removeEventListener('online', logUserOnline);
      window.removeEventListener('offline', logUserOffline);
    };
  }, []);
};
